{
    "Accessibility Menu": "Accessibility Menu",
    "Reset settings": "Reset settings",
    "Close": "Close",
    "Content Adjustments": "Content Adjustments",
    "Adjust Font Size": "Adjust Font Size",
    "Highlight Title": "Highlight Title",
    "Highlight Links": "Highlight Links",
    "Readable Font": "Readable Font",
    "Color Adjustments": "Color Adjustments",
    "Dark Contrast": "Dark Contrast",
    "Light Contrast": "Light Contrast",
    "High Contrast": "High Contrast",
    "High Saturation": "High Saturation",
    "Low Saturation": "Low Saturation",
    "Monochrome": "Monochrome",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Visual & Navigation Aids",
    "Additional Tools": "Additional Tools",
    "Reading Guide": "Reading Guide",
    "Stop Animations": "Stop Animations",
    "Big Cursor": "Big Cursor",
    "Screen Reader": "Screen Reader",
    "Hide Images": "Hide Images",
    "Image Tooltips": "Image Tooltips",
    "Page Structure": "Page Structure",
    "Super Focus": "Super Focus",
    "Magnifier": "Magnifier",
    "Increase Font Size": "Increase Font Size",
    "Decrease Font Size": "Decrease Font Size",
    "Letter Spacing": "Letter Spacing",
    "Line Height": "Line Height",
    "Font Weight": "Font Weight",
    "Dyslexia Font": "Dyslexia Font",
    "Language": "Language",
    "Open Accessibility Menu": "Open Accessibility Menu",
    "Accessibility Profiles": "Accessibility Profiles",
    "Seizure Safe Profile": "Seizure Safe Profile",
    "Stops animations and reduces color saturation.": "Stops animations and reduces color saturation.",
    "Blind Profile": "Blind Profile",
    "Activates the screen reader for auditory navigation.": "Activates the screen reader for auditory navigation.",
    "Visually Impaired Profile": "Visually Impaired Profile",
    "Enhances contrast and readability for low vision.": "Enhances contrast and readability for low vision.",
    "ADHD Friendly Profile": "ADHD Friendly Profile",
    "Reduces distractions for better focus.": "Reduces distractions for better focus.",
    "Cognitive & Learning Profile": "Cognitive & Learning Profile",
    "Helpful tools for reading and comprehension.": "Helpful tools for reading and comprehension.",
    "Motor Impaired Profile": "Motor Impaired Profile",
    "Optimizes the site for keyboard-only navigation.": "Optimizes the site for keyboard-only navigation.",
    "Headings": "Headings",
    "Landmarks": "Landmarks",
    "Links": "Links",
    "Focus element": "Focus element",
    "Visit link": "Visit link"
}